import { render, staticRenderFns } from "./exchange-rates-dialog.vue?vue&type=template&id=6354d4ab&scoped=true&"
import script from "./exchange-rates-dialog.vue?vue&type=script&lang=ts&"
export * from "./exchange-rates-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./exchange-rates-dialog.vue?vue&type=style&index=0&id=6354d4ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6354d4ab",
  null
  
)

export default component.exports